import { API_URL } from './config';
import { apiFetch } from './apiFetch';

export const getSourceLang = async (site: string) => {
  try {
    const response = await apiFetch(`${API_URL}/getSourceLang?site=${site}`);

    const lang = await response.json();

    return lang;
  } catch (err) {
    console.log(err);
  }
};
